import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { PatientEventLogsFilter, ToastService } from '../../core';
import { DiaryService } from '../../services';
import { BaseComponent, PaginationComponent, SortEvent } from '../../shared';
import { HistoryFiltersComponent } from '../history-filters';
import { HistoryTableComponent } from '../history-table';


/**
 * Component for diary logs table in patient history page.
 */
@Component({
	selector: 'tsp-diary-table',
	imports: [
		PaginationComponent,
		HistoryTableComponent,
		HistoryFiltersComponent
	],
	templateUrl: './diary-table.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class DiaryTableComponent extends BaseComponent {

	private readonly diarySrv = inject(DiaryService);
	private readonly toastSrv = inject(ToastService);

	isReadonly = input.required<boolean>();

	filters = this.diarySrv.diaryFilters;
	sortOrder = this.diarySrv.diarySortOrder;
	diaries = this.diarySrv.diaries;

	collectionSize = computed(() => this.diarySrv.diaryCount());
	pageNumber: number = 1;
	pageSize: number = 10;


	/**
	 * Update diaries list according to filters.
	 */
	updateList(filters: PatientEventLogsFilter | undefined): void {
		this.filters.set(filters ? { ...filters, page: 1, top: 10 } : { ...this.diarySrv.DEFAULT_DIARY_FILTERS });
		this.pageNumber = 1;
		this.pageSize = 10;
		this._search();
	}

	/**
	 * Update list by page number.
	 */
	updatePageNumber(): void {
		this.filters.update(f => ({ ...f, page: this.pageNumber }));
		this._search();
	}

	/**
	 * Update list by page size.
	 */
	updatePageSize(): void {
		this.filters.update(f => ({ ...f, top: this.pageSize }));
		this._search();
	}

	/**
	 * Sort list according to sort order.
	 */
	sort(order: SortEvent): void {
		this.filters.update(f => ({
			...f,
			sortOrder: { name: order.column, desc: order.direction === 'desc' },
			page: 1,
			top: 10
		}));
		this.pageNumber = 1;
		this.pageSize = 10;
		this._search();
	}

	private _search(): void {
		if (!this.collectionSize() || Math.ceil(this.collectionSize() / this.pageSize) >= this.pageNumber) {
			this.diarySrv.searchDiaries().subscribe({
				error: () => this.toastSrv.showError(this.labels().HISTORY_FILTERS_COMPONENT_SEARCH_ERROR)
			});
		}
	}
}
